/* istanbul ignore file */
import React from 'react';
import CandidatesBreadcrumbs from 'domain/recruiting/candidate/shared/CandidatesBreadcrumbs';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const CreateCandidateApplicationBreadcrumbs = () => {
  return (
    <CandidatesBreadcrumbs>
      <CreateBreadcrumbItem entity="Candidate Application" />
    </CandidatesBreadcrumbs>
  );
};

export default CreateCandidateApplicationBreadcrumbs;
